module.exports = __webpack_public_path__ + "img/icon_data_empty.b4d9d60f.png";